import React, { useRef, useEffect } from 'react';
import { TweenLite } from 'gsap';
import ContextMenu, { ContextMenuAction } from './ContextMenu';

export interface ICardProps {
    style?: React.CSSProperties;
    rightBadgePanelstyle?: React.CSSProperties;
    divKey?: number;
    badge?: string;
    rightBadgePanel?: string | React.ReactElement;
    infoBar?: string | React.ReactElement;
    actions?: CardAction[];
    actionPanelStyle?: React.CSSProperties;
    contextActions?: ContextMenuAction[];
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    onDoubleClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    children?: React.ReactElement[] | React.ReactElement;
    className?: string;
    newContext?: boolean;
    isHidden?: boolean;
    showMenu?: boolean;
    isHighlighted?: boolean;
    collapse?: boolean;
}

const Card: React.FC<ICardProps> = (props) => {
    const popupEl = useRef(null);
    // const [actionMenuShowing, setActionMenuShowing] = useState(false);

    let cardClassName = 'dlc-card';
    cardClassName += props.badge || props.rightBadgePanel ? ` has-badge` : '';
    cardClassName += (props.actions && props.actions.length > 0) || (props.contextActions && props.contextActions.length > 0) ? ` has-actions` : '';
    if (props.className) {
        cardClassName += ' ' + props.className;
    }
    if (props.actions && props.actions.length > 0) {
        cardClassName += ' has-actions';
    }

    useEffect(() => {
        if (popupEl.current) {
            TweenLite.to(popupEl.current, 0, { height: '2rem', width: '1.7rem', opacity: '0', pointerEvents: 'none' });
        }
    });

    const clickAction = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, action: CardAction) => {
        event.stopPropagation();
        action.action();
    };

    const togglePopup = (state: boolean) => {
        if (props.actions && props.actions.length > 0) {
            if (state) {
                TweenLite.to(popupEl.current, 0.2, { height: 'auto', width: 'auto', opacity: '1', pointerEvents: 'inherit' });
            } else {
                TweenLite.to(popupEl.current, 0.2, { height: '2rem', width: '1.7rem', opacity: '0', pointerEvents: 'none' });
            }
        }
    };

    // const actionEnter = () => {
    //     if (props.newContext) {
    //         setActionMenuShowing(true);
    //     }
    // };

    // const actionOut = () => {
    //     if (props.newContext) {
    //         setActionMenuShowing(false);
    //     }
    // };

    // useEffect(() => {
    //     // setInterval(() => console.log('showing', actionMenuShowing), 1000);
    // }, []);

    // useEffect(() => {
    //     if (!actionMenuShowing) {
    //         setTimeout(() => {
    //             togglePopup(false);
    //         }, 1000);
    //     }
    // }, [actionMenuShowing]);

    const badgeStyle: React.CSSProperties = {
        position: 'relative',
        marginTop: '-1px',
        marginLeft: '-1px',
    };

    return (
        <div
            key={props.divKey}
            onDoubleClick={(e) => props.onDoubleClick && props.onDoubleClick(e)}
            onClick={(e) => props.onClick && props.onClick(e)}
            className={cardClassName}
            // onMouseEnter={actionEnter}
            // onMouseLeave={actionOut}
            style={{ ...props.style, display: props.isHidden ? 'none' : 'block' }}
        >
            <div className="card-header-row">
                <div className="left-info-badge">
                    <div className="badge">
                        {props.badge && (
                            <p className="badge-content" style={badgeStyle}>
                                {props.badge}
                            </p>
                        )}
                    </div>
                    <div className="info-bar">
                        {props.infoBar && props.isHighlighted &&
                        <span style={{background: 'yellow', border: '.5px solid gray', borderRadius: '5%'}}>
                            &nbsp;{props.infoBar}&nbsp;
                        </span>}
                        {props.infoBar && !props.isHighlighted &&
                        <span style={{margin: '0'}}>
                            {props.infoBar}
                        </span>}
                    </div>
                </div>
                <div className="right-info-badge" style={{ gap: '1rem' }}>
                    {props.rightBadgePanel
                     && <span style={!!props.rightBadgePanelstyle ? props.rightBadgePanelstyle : {}} className="right-info-badge-content">{props.rightBadgePanel}</span>}
                    {/* {(props.newContext) && <ContextMenu isVisible={actionMenuShowing} actions={props.contextActions} />} */}
                    {!!props.newContext && !!props.showMenu && <ContextMenu isVisible={props.showMenu} actions={props.contextActions} />}
                </div>
            </div>
            {/*Removing to tighten up card height. props.children && <br />*/}
            {!props.collapse && props.children && <br />}
            {props.children}
            {!props.newContext && (
                <>
                    <div
                        style={props.actionPanelStyle}
                        className="actions-panel"
                    >
                        <span className="options-button" onMouseOver={() => togglePopup(true)} />
                    </div>
                    <div className="actions-popup-mask" ref={popupEl} onMouseLeave={() => togglePopup(false)}>
                        <div className="actions-popup">
                            <div className="actions-popup-header">Options</div>
                            {props.actions?.map((action: CardAction, index: number) => (
                                <div
                                    className="action"
                                    key={index}
                                    onClick={(e) => clickAction(e, action)}
                                    style={{ width: '14rem', minHeight: '2.5rem' }}
                                >
                                    {action.text}
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export type CardAction = {
    text: string;
    action: () => void;
};

Card.defaultProps = {
    newContext: false,
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/common/Card.redesign.tsx